export default "__VITE_ASSET__DYT4lQQf__"